import React from 'react';

export const CustomLoader: React.FC<{ size?: number }> = ({ size = 80 }) => {
  const stroke = Math.max(2, Math.floor(size / 12));
  return (
    <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <div
        style={{
          width: size,
          height: size,
          borderRadius: '50%',
          border: `${stroke}px solid rgba(79,169,77,0.2)`,
          borderTop: `${stroke}px solid var(--theme-default)`,
          boxSizing: 'border-box',
          animation: 'custom-loader-spin 1s linear infinite',
        }}
        aria-label="loading"
      />
      <style>{`@keyframes custom-loader-spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
};
